module.exports = __webpack_public_path__ + "static/media/hindiB.b57adcc6.webp";